<template>
  <div class="my-item-div1">
    <el-container>
      <el-aside width="260px">
        <LeftMenu :itemMenu="itemMenu"></LeftMenu>
      </el-aside>
      <el-main style="padding: 20px 0px 20px 50px;overflow:visible">
        <router-view :key="$route.fullPath"></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import LeftMenu from '@/components/item/LeftMenu'
  import Vuex from 'vuex'

  import {
    getLeftMenu,
    getItem,
  } from '@/api/item.js'

  export default {
    name: "ItemIndex",
    data: function() {
      return {
        itemMenu: [],
      }
    },
    components: {
      LeftMenu,
    },
    methods: {},
    created() {
      getLeftMenu("navigation/get?pagesize=99&&number=1", this.$data);
      this.$store.state.activeIndex = "3";
    },
    computed: {
      ...Vuex.mapGetters(["getInfo"])
    },
  }
</script>

<style>
  .my-item-div1 {
    width: 1200px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/item/ItemIndex.vue